import { render, staticRenderFns } from "./CollectItems.vue?vue&type=template&id=e2c6f262&scoped=true&"
import script from "./CollectItems.vue?vue&type=script&lang=js&"
export * from "./CollectItems.vue?vue&type=script&lang=js&"
import style0 from "./CollectItems.vue?vue&type=style&index=0&id=e2c6f262&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c6f262",
  null
  
)

export default component.exports